import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const REGISTER_ROOKIE_COMPANY = gql`
  mutation RegisterRookieCompany(
    $districtId: Int!,
    $companyId: Int!,
    $companyName: String!,
    $companyStreet: String!,
    $companyZip: String!,
    $companyCity: String!,
    $contactFirstname: String!,
    $contactLastname: String!,
    $contactPhone: String!,
    $contactEmail: String!,
    $jobEntries: [InRookieJobEntry!]!

  ) {
    rookieRegisterCompany(
      companyData: {
      districtId: $districtId,
      company: {
        companyProfileId: $companyId,
        companyName: $companyName,
        street: $companyStreet,
        zip: $companyZip,
        city: $companyCity
      },
      contact: {
        firstname: $contactFirstname,
        lastname: $contactLastname,
        phone: $contactPhone,
        email: $contactEmail
      },
      entries: $jobEntries
    }) {
      type,
      message
    }
  }

`;
